<div class="input-edit-row">
  <input #inputCheck
         [ngClass]="{'ng-invalid': hasError }"
         class="server-name"
         value="{{inputValue}}"
         [disabled]="inputIsDisable"
         (keyup)="testValidation(inputCheck.value, inputCheck, $event);trimValue($event)"
         (input)="testValidation(inputCheck.value, inputCheck, $event)"
         (change)="testValidation(inputCheck.value, inputCheck, $event)"
         autocomplete="off"/>
  <i *ngIf="!hasError"
     class="fa fa-check input-validation"
     aria-hidden="true"></i>
  <div class="input-edit-btn-area">
    <i *ngIf="isAdmin"
       class="fa fa-edit transition text-tooltip"
       aria-hidden="true"
       title-popup="Edit"
       (click)="inputOnClick(inputCheck)"
       [hidden]="inputIsHidden"></i>
    <button class=" transition text-tooltip tooltip-edit"
            [hidden]="!inputIsHidden"
            (click)="inputOnSave(inputCheck)"
            [disabled]="hasError"
            title-popup="Save">
      <i class="fa fa-check"
         [ngClass]="{'disabled':hasError}"
         aria-hidden="true"></i>
    </button>
    <button class="transition text-tooltip tooltip-edit"
            title-popup="Cancel"
            [hidden]="!inputIsHidden"
            (click)="inputOnCancel(inputCheck)">
      <i class="fa fa-times"
         aria-hidden="true"></i>
    </button>
  </div>
</div>
<div class="alert alert-danger alert-validate error-validate"
     *ngIf="hasError">{{errorMessage}}
</div>
